import React from 'react';
import { connect } from 'react-redux'
import LastLists from '../../containers/drop/Lists'
import Setting from '../../containers/drop/Setting'



const Layout = ({ children }) => {
    return (
        <div>
            { children }
            <LastLists />
            <Setting />
        </div>
    )
}




export default connect(null, null)(Layout);


// WEBPACK FOOTER //
// ./src/components/layout/MainLayout.js